import { Button } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import * as React from 'react';
import SegmentStore from '../../../SegmentStore';
import { T } from '../../../Translations';

interface Props {
  segmentStore: SegmentStore;
}

const isComplete = (segmentStore: SegmentStore): boolean =>
  segmentStore.segmentResource
    .andThen((sr) => sr.payload.status)
    .map((status) => status === 'Complete')
    .getOrElseValue(false);

const SurveyCompleted: React.FC<Props> = ({ segmentStore }) => {
  if (isComplete(segmentStore)) {
    return (
      <div data-test-survey-segment={true}>
        <h3>
          <T kind="Thank you!" />
        </h3>
        <p data-test-survey-segment-complete={true}>
          <T kind="This segment has been completed." />
        </p>
      </div>
    );
  }

  return (
    <div data-test-survey-segment={true}>
      <p>
        <T kind="This survey is no longer available." />
      </p>
      <Button
        color="green"
        radius="sm"
        onClick={() => segmentStore.completeAndAdvance()}
        data-intercom-target="retired-survey-complete-button"
      >
        <T kind="Mark Complete and Continue" />
      </Button>
    </div>
  );
};

export default observer(SurveyCompleted);
